import { ExternalLink } from "lucide-react";
import { getInstitutionGuide } from "../../data/institutionGuides";

export function InstitutionGuideLink({ instituicao }: { instituicao: string }) {
  const guide = getInstitutionGuide(instituicao);
  if (!guide) return null;
  return (
    <a
      href={guide.href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="institution-guide-link"
      className="text-xs text-emerald-400 hover:text-emerald-300 underline mt-1.5 inline-flex items-center gap-1 transition-colors"
    >
      {guide.label}
      <ExternalLink aria-hidden="true" className="h-3 w-3" />
    </a>
  );
}
